import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IStoreAuth } from './types';

const initialState: IStoreAuth = {
  capricaGitSha: '',
  updateAvailable: false,
};

export default createSlice({
  name: 'auth',
  initialState,
  reducers: {
    updateCapricaGitSha: (draft, action: PayloadAction<string>) => {
      const newGitSha = action.payload;
      if (draft.capricaGitSha === '') {
        // only update git sha once - the version of Caprica cannot change unless full page reload is performed
        // if we store the new sha in the state, it will be misleading in the UI
        draft.capricaGitSha = newGitSha;
      } else if (draft.capricaGitSha !== newGitSha) {
        draft.updateAvailable = true;
      }
    },
  },
});
